<template>
  <div>
    <TopTabbar />
    <div class="content">
      <div class="head">
        <div class="user">
          <div class="photo">
            <img src="https://img3.gemtec.ltd/20190523201047.png" />
          </div>
          <div class="username">{{ username }}</div>
        </div>
      </div>
      <div class="body">
        <div class="line">
          <div class="itemWrap" @click="showtoast()">
            <img
              class="img"
              src="https://img3a.gemtec.ltd/%E4%BC%9A%E5%91%98%402x.png"
            />
            <div class="text">会员</div>
          </div>
          <div class="itemWrap" @click="popup()">
            <img
              class="img"
              src="https://img3a.gemtec.ltd/%E8%AE%BE%E7%BD%AE%402x.png"
            />
            <div class="text">设置</div>
          </div>
          <div class="itemWrap" @click="$router.push('history')">
            <img
              class="img"
              src="https://img3a.gemtec.ltd/%E5%8E%86%E5%8F%B2%402x.png"
            />
            <div class="text">历史</div>
          </div>
        </div>
        <div class="line">
          <div class="itemWrap" @click="order()">
            <img class="img" src="https://img3a.gemtec.ltd/dingdan.png" />
            <div class="text">订单</div>
          </div>
          <div class="itemWrap" @click="openScreen()">
            <img
              class="img"
              src="https://img3a.gemtec.ltd/%E8%BD%AE%E6%92%AD%E9%A2%84%E8%A7%88%402x.png"
            />
            <div class="text">轮播</div>
          </div>
          <!-- <div class="itemWrap" @click="$router.push('activitylist')">
                        <img
                            class="img"
                            src="https://img3a.gemtec.ltd/%E6%B4%BB%E5%8A%A8%E9%A2%84%E8%A7%88%402x.png"
                        />
                        <div class="text">活动</div>
                    </div> -->
        </div>
      </div>
    </div>
    <!-- 底部导航条 -->
    <Tabbar />
    <!-- 弹出框 -->
    <van-popup v-model="show" style="border-radius: 4px">
      <div class="popup">
        <div class="logo">
          <img src="../../assets/img/head.jpg" alt />
        </div>
        <div class="box">
          <div class="updata">
            <div class="left">图片轮播时间</div>
            <div class="updata_right">
              <input
                type="text"
                v-model="srceenTime"
                placeholder="仅支持整数"
                onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                @keypress="submit"
              />
              <label>秒</label>
            </div>
          </div>
          <div class="cache">
            <div class="left">清除缓存</div>
            <div class="right" @click="clean()">清除</div>
          </div>
          <div class="edition">
            <div class="left">版本</div>
            <div class="right" @click="update2()">更新</div>
          </div>
          <div class="btn" @click="quit()">退出账号</div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="Loadshow"
      style="border-radius: 4px"
      overlay-class="overOpa"
      @click="closeScreen()"
    >
      <ListScreen @closeScreen="closeScreen" />
    </van-popup>
  </div>
</template>
<script>
import ListScreen from "@/components/ListScreen.vue";
import Tabbar from "@/components/Tabbar.vue";
import TopTabbar from "@/components/TopTabbar.vue";
import { userinfo, screen, orderinfo } from "../../api/http.js";
import { Swipe, SwipeItem, Dialog } from "vant";
import Vue from "vue";
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Dialog);
export default {
  data() {
    return {
      show: false,
      userimg: "../../assets/img/20190523201047.png",
      username: "",
      imglist: [],
      Loadshow: false,
      srceenTime: ""
    };
  },
  components: {
    Tabbar,
    TopTabbar,
    ListScreen
  },
  computed: {
    viewheight() {
      return this.$store.state.screenHeight;
    }
  },
  methods: {
    popup: function() {
      this.show = !this.show;
    },
    quit: function() {
      localStorage.removeItem("login_token");
      localStorage.removeItem("user_type");

      if(process.env.VUE_APP_ISAPP=='true'){
        window.electronAPI.weiXinLoginQuit()
        this.$router.push({path:'/'})
      } else {
        this.$router.go(0);
      }
      
    },
    clean() {
      localStorage.removeItem("ipad_search_history");
      localStorage.removeItem("history");
      this.$toast("已清除");
    },
    showtoast() {
      this.$toast("该功能未开放");
    },
    update() {
      this.$toast("已更新");
    },
    update2() {
      this.$toast("已更新至最新版本");
      window.location.href = "/";
    },
    loadImg() {
      screen().then(res => {
        let data = res.data;
        for (let i in data.image) {
          this.imglist.push(data.image[i].file_path);
        }
        console.log(this.imglist);
      });
    },
    openScreen() {
      sessionStorage.setItem("screen", 1);
      this.Loadshow = true;
    },
    closeScreen() {
      sessionStorage.removeItem("screen");
      this.Loadshow = false;
    },
    submit: function(e) {
      if (event.keyCode == 13) {
        //enter键
        event.preventDefault(); //禁止默认事件（默认是换行）
        if (this.srceenTime == "") {
          localStorage.setItem("screenTime", "5");
        } else {
          localStorage.setItem("screenTime", this.srceenTime);
        }
        window.location.reload();
      }
    },
    order() {
      this.$router.push("/orderList");
    }
  },
  mouted() {},
  activated() {
    let login_token = localStorage.getItem("login_token");
    if (login_token == null) {
      this.$router.replace("login");
    } else {
      orderinfo(login_token).then(res => {
        if (res.code == 1) {
          this.userimg =
            res.data.avatarUrl || require("../../assets/img/user.jpg");
          this.username = res.data.user_name;
        }
      });
      this.loadImg();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  margin-top: 44px;
  .head {
    // width:1024px;
    height: 146px; //-30px
    // background:rgba(25,255,255,1);
    background: url("../../assets/img/beijin.jpg") no-repeat;
    background-size: 1024px 176px;
    margin-bottom: 49px;
    padding-top: 30px;
    .user {
      .photo {
        width: 73px;
        height: 73px;
        border-radius: 4px;
        margin-bottom: 17px;
        margin: auto;
        display: block;
        // margin-top: 30px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .username {
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .body {
    .line {
      display: flex;
      justify-content: center;
      padding: 10px 0px;
      .itemWrap {
        box-shadow: 0 0 27px #12131313;
        margin: 0px 10px;
        // padding: 20px 30px;
        box-sizing: border-box;
        height: 131px;
        width: 131px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .img {
          width: 30px;
          height: 30px;
          object-fit: contain;

          //   margin: 0px auto;
          display: block;
        }
        .text {
          color: #c9a864;
          font-size: 16px;
          height: 21px;
          margin-top: 20px;
          line-height: 21px;
          text-align: center;
        }
      }
    }
  }
}
.popup {
  width: 384px;
  height: 407px;
  background: rgba(255, 255, 255, 1);
  z-index: 2;
  padding-top: 63px;
  padding-bottom: 55px;
  padding-left: 40px;
  padding-right: 40px;
  .logo {
    width: 92px;
    height: 92px;
    background: rgba(62, 33, 14, 1);
    border-radius: 4px;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .box {
    margin-top: 20px;
    .left {
      font-size: 14px;
    }
    .right {
      width: 75px;
      height: 27px;
      font-size: 12px;
      border: 1px solid rgba(32, 32, 32, 1);
      border-radius: 4px;
      line-height: 27px;
      text-align: center;
    }
    .cache,
    .updata,
    .edition {
      display: flex;
      height: 59px;
      line-height: 59px;
      justify-content: space-between;
      align-items: center;
    }
    .cache {
      border-bottom: 1px solid rgba(141, 141, 141, 1);
    }
    .updata {
      border-bottom: 1px solid rgba(141, 141, 141, 1);
    }
    .edition {
      margin-bottom: 55px;
    }
    .btn {
      width: 170px;
      height: 44px;
      background: rgba(62, 33, 14, 1);
      border-radius: 4px;
      line-height: 44px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin: auto;
    }
    .updata_right {
      input {
        font-size: 12px;
        height: 40px;
        margin-top: 10px;
        background: #f7f8fa;
        padding: 0px 4px;
        border: 0px;
        border-radius: 4px;
        width: 70px;
        vertical-align: middle;
        line-height: 40px;
      }
      label {
        font-size: 12px;
        line-height: 60px;
        height: 60px;
        margin-left: 5px;
      }
    }
  }
}
.screen {
  overflow: hidden;
}
</style>
<style>
.overOpa {
  background-color: rgba(0, 0, 0, 1) !important;
}
</style>
